import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { PercentPie } from 'components/importer/import_requests/porcent-pie';
import { setMappingFile } from '../store/actions/importer';
import { setRecordIndex, getFileRecord } from '../store/actions/mapping';
import {
  getCurrentFile,
  getColumnMappings,
  getRecordsCount,
  getFieldsOptions,
  getRecordIndex,
  getRecord
} from '../store/selectors';

export function MappingMappedData({
  columnMappings,
  currentFile,
  fieldOptions,
  getFileRecord,
  record,
  recordsCount,
  recordIndex,
  setRecordIndex
}) {
  const [showEmptyColumn, setShowEmptyColumn] = useState(false);
  const [recordContent, setRecordContent] = useState([]);

  const setIndex = (count) => {
    const index = recordIndex + count;
    if (index === recordsCount) {
      setRecordIndex(0);
      return;
    }
    if (index < 0) {
      setRecordIndex(recordsCount - 1);
      return;
    }
    setRecordIndex(index);
  };

  const handleShowEmptyColumn = (e) => {
    e.stopPropagation();
    setShowEmptyColumn(!showEmptyColumn);
  };

  const columnHasField = (column) => {
    const columnMapping = column.columnMapping;
    return fieldOptions.find(option => option[1] === columnMapping.fieldName);
  };

  const countEmptyColumnMapping = () => {
    return columnMappings.filter((column) => {
      const field = columnHasField(column);
      if (!field || column.columnCount === 0) return true;
    }).length;
  };

  useEffect(() => {
    getFileRecord(false);
  }, [currentFile]);

  useEffect(() => {
    getFileRecord(false);
  }, [recordIndex]);

  useEffect(() => {
    if (!record) return;
    setRecordContent(record.content);
  }, [record]);
  
  const renderColumnMapping = (column) => {
    const columnMapping = column.columnMapping;
    if (column.columnCount === 0 && !showEmptyColumn) return;

    const field = columnHasField(column);
    if (!field && !showEmptyColumn) return;

    return (
      <tr className={classNames({ selected: column.columnCount != 0 })} key={columnMapping.id}>
        <td>{field && field[0]}</td>
        <td>{columnMapping.name}</td>
        <td>{record && recordContent[columnMapping.index]}</td>
        <td>
          <PercentPie columnCount={column.columnCount} recordsCount={recordsCount} />
        </td>
      </tr>
    );
  };

  return (
    <React.Fragment>
      <div className="mb-4">
        <h3 className="semi-bold mb-4">Mapped Data</h3>
        <p className="mt-4">
          Your uploaded data files have been automatically mapped for you by the imports system.
          You can review the mappings for each file in the table below.
        </p>
      </div>
      <div className="mapped-data mb-5 table-scroll">
        <table className="table table-bordered thead-inverse js-mapping-table mapping-table show-zero-columns">
          <thead>
            <tr>
              <th className="text-center dark">Buildout Field</th>
              <th className="text-center dark">CSV Field</th>
              <th className="text-center dark">
                <small className="pull-left text-muted last-sample clickable" onClick={()=> setIndex(-1)}>
                  &lt;&lt;
                </small>
                Sample
                <small className="pull-right text-muted next-sample clickable" onClick={()=> setIndex(1)}>
                  &gt;&gt;
                </small>
              </th>
              <th className="dark utilization">%</th>
            </tr>
          </thead>
          <tbody className="class_name">
            {columnMappings.map(renderColumnMapping)}
          </tbody>
        </table>
        <div className="zero-column-expand-message">
          {countEmptyColumnMapping()} empty columns were hidden.
          <a onClick={handleShowEmptyColumn}>{showEmptyColumn ? 'Hide' : 'Show'} empty columns</a>
        </div>
      </div>
    </React.Fragment>
  );
}

MappingMappedData.propTypes = {
  columnMappings: PropTypes.array.isRequired,
  currentFile: PropTypes.object.isRequired,
  fieldOptions: PropTypes.array.isRequired,
  getFileRecord: PropTypes.func.isRequired,
  record: PropTypes.object,
  recordIndex: PropTypes.number.isRequired,
  recordsCount: PropTypes.number.isRequired,
  setRecordIndex: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  currentFile: getCurrentFile(state),
  columnMappings: getColumnMappings(state),
  recordIndex: getRecordIndex(state),
  recordsCount: getRecordsCount(state),
  record: getRecord(state),
  fieldOptions: getFieldsOptions(state)
});

const mapDispatchToProps = {
  setMappingFile,
  setRecordIndex,
  getFileRecord
};

export default connect(mapStateToProps, mapDispatchToProps)(MappingMappedData);
